<template>
  <el-dialog title="PDF Preview" :visible.sync="modal" top="15vh" width="1000px" @close="handleClose">
    <div v-if="loading" class="text-center">
        <h2><i class="el-icon-loading"></i> Loading...</h2>
    </div>
    <div v-else>
        <pdf
            v-for="i in numPages"
            :key="i"
            :src="src"
            :page="i"
            :style="`width: 100%; margin-bottom: 10px; ${ numPages > 1 && i < numPages ? 'border-bottom: 1px solid grey;' : ''}`"
            @progress="progress = $event"
        ></pdf>
    </div>
  </el-dialog>
</template>

<script>
import pdf from 'vue-pdf'

export default {
    components: { pdf },
    data: () => ({
        modal: false,
        loading: false,
        numPages: undefined,
        src: null,
        progress: null
    }),
    methods: {
        handlePDF(pdfUrl){
            this.modal = !this.modal
            if(pdfUrl){
                this.loading = true;
                this.src = pdf.createLoadingTask(pdfUrl);
                this.src.promise.then(pdf => {
                    this.numPages = pdf.numPages;
                })
                .finally(() => this.loading = false)
            }
        },
        handleClose(){
            this.src = null;
            this.numPages = undefined;
        }
    }
}
</script>